// src/utils/iconUtils.js

import iconData from "../iconFileNames.json";

export const getIconFileName = (seasonName) => {
        function preprocess(str) {
                return str
                        .toLowerCase()
                        .replace(/[^\w\s]/g, "") // Remove punctuation
                        .replace(/\d+/g, "") // Remove numbers
                        .trim()
                        .split(/\s+/);
        }

        const { iconFileNames, aliases } = iconData;
        // Prefer the downloaded icon for this exact season before fuzzy matching.
        const exactName = seasonName.replace(/[<>:"/\\|?*]/g, "").replace(/\s+/g, " ").trim();
        const exactMatch = iconFileNames.find((name) => name.toLowerCase() === exactName.toLowerCase());
        if (exactMatch) return exactMatch;
        const seasonWords = preprocess(seasonName);
        let maxCommonWords = 0;
        let bestMatch = "iRacing-Icon-BW-White"; // Default icon
        let minExtraWords = Number.MAX_SAFE_INTEGER;

        // Build a list of entries to check: base names + aliases
        const entries = iconFileNames.map((name) => ({ name, original: name }));
        aliases.forEach(({ alias, original }) => {
                entries.push({ name: alias, original });
        });

        entries.forEach(({ name, original }) => {
                const iconWords = preprocess(name);
                const commonWords = iconWords.filter((word) => seasonWords.includes(word));
                if (commonWords.length > maxCommonWords) {
                        maxCommonWords = commonWords.length;
                        bestMatch = original; // Return the original file name
                        minExtraWords = iconWords.length - commonWords.length;
                } else if (commonWords.length === maxCommonWords) {
                        const extraWords = iconWords.length - commonWords.length;
                        if (extraWords < minExtraWords) {
                                bestMatch = original;
                                minExtraWords = extraWords;
                        }
                }
        });

        return bestMatch;
};
